export function getDaysRemaining(futureDate: Date) {
  const todayDate = new Date();
  if(Math.ceil((new Date(futureDate).getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24)) < 0)
    return 0
  else
    return Math.ceil((new Date(futureDate).getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24))
}
